__turbopack_context__.v({
  "blogsecTravelUpdateBtn": "BlogSecTravelUpdate-module__U9hU_G__blogsecTravelUpdateBtn",
  "blogsecTravelUpdateContainer": "BlogSecTravelUpdate-module__U9hU_G__blogsecTravelUpdateContainer",
  "blogsecTravelUpdateForm": "BlogSecTravelUpdate-module__U9hU_G__blogsecTravelUpdateForm",
  "blogsecTravelUpdateHeader": "BlogSecTravelUpdate-module__U9hU_G__blogsecTravelUpdateHeader",
  "blogsecTravelUpdateInput": "BlogSecTravelUpdate-module__U9hU_G__blogsecTravelUpdateInput",
  "blogsecTravelUpdateSection": "BlogSecTravelUpdate-module__U9hU_G__blogsecTravelUpdateSection",
  "fieldError": "BlogSecTravelUpdate-module__U9hU_G__fieldError",
  "inputError": "BlogSecTravelUpdate-module__U9hU_G__inputError",
});
